(function ($) {

	let $contact_form = $("form#gp-ajax-form--checkout_contact")

	// Show/hide shipping inputs
	$contact_form.find("input[name='add_billing_info']").change(toggle_billing_info)

	function toggle_billing_info() {
		$(".checkout-contact__billing-address").slideToggle(250)
	}

})(jQuery)